<template>
  <div>
    <sButton
      :disabled="loading"
      :loading="loading"
      @click="open">
      {{ $t(`Tenders.PublishAuction`) }}
    </sButton>
    <div
      v-if="add_data"
      class="add-auction-data-fullscreen">
      <component
        v-if="steps[step - 1] && steps[step - 1].component"
        :is="steps[step - 1].component"
        v-bind="steps[step - 1].props"
        :auction.sync="add_data"/>
    </div>
  </div>
</template>
<script>
import TenderTerms from 'pages/tender creation/TenderTerms.vue'
import SpecifyTender from 'pages/tender creation/SpecifyTender.vue'
import WeRecommendTender from 'pages/tender creation/WeRecommendTender.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()
import { tenderMixin } from 'mixins'

export default {
  name: 'completeRetraining',
  mixins: [ tenderMixin ],
  data() {
    return {
      dialog: false,
      // add_data: false,
      steps: [],
      loading: false
    }
  },
  props: {
    tender: Object,
    validate: Function
  },
  computed: {
    copyQualifiedBidsToAuction () {
      return this.$can('is', 'copyQualifiedBidsToAuction')
    },
    isRowMinStepPercent() {
      return this.tender.biddingType?.bidStepAvailable && this.tender.lots.some(lot => !lot.minimalStepPercent)
    },
    isRowInitialAmount() {
      return this.tender.biddingType?.initialRateAvailable && this.tender.lots.some(lot => !lot.initialAmount)
    },
    isNeewFirstStep() {
      return this.copyQualifiedBidsToAuction || this.isRowMinStepPercent || this.isRowInitialAmount
    },
    allSteps() {
      const result = []
      //if (this.isNeewFirstStep) {
      result.push({
        text: 'WeRecommendAddData',
        component: 'WeRecommendTender',
        disabled: !this.isNeewFirstStep,
        props: {
          copyQualifiedBidsToAuction: this.copyQualifiedBidsToAuction,
          isRowMinStepPercent: this.isRowMinStepPercent,
          isRowInitialAmount: this.isRowInitialAmount
        }
      })
      //}
      result.push({
        text: 'RefinePurchase',
        component: 'SpecifyTender',
        props: {
          auctionFirstStep: !this.isNeewFirstStep
        },
      })
      result.push({ text: 'TermsOfHolding', component: 'TenderTerms'})

      return result
    },
    info() {
      return this.$store.getters['getNewTenderInfo']
    },
    step() {
      return this.info?.step
    },
    add_data: {
      get() {
        return this.info?.dialog
      },
      set(val) {
        if ( val ) {
          this.$store.commit('setNewTenderInfo', {mode: 'add-data', step: this.info.step || 1, steps: this.steps.map(el => el.text), dialog: val })
        } else {
          this.$emit('getItem', true )
          this.$store.commit('setNewTenderInfo', {})
          this.$store.commit('setDefaultTender')
        }
      }
    },
  },
  methods: {
    open() {
      this.validate()
      let all_declined = this.tender.bids.every(bid => {
        return bid.bidDetails.filter(det => det.bidStatus == 'ACTIVE').every(det => {
          return det.prequalification?.status == 'CANCELED' || det.prequalification?.status == 'UNSUCCESSFULL'
        })
      })

      if ( all_declined ) {
        let loading = true

        const model = {}
        const key = `copyAllBids_${this.tender.tenderId}`
        if (this.$can('is', 'copyQualifiedBidsToAuction')) {
          model.copyBidsToAuction = !!this.$_getPropFromLocalStorage(key, 1, true)
        }

        this.$Modal.confirm({
          closable: true,
          width: 736, title: this.$t('Tenders.NoParticipantWasAgreedOn'),
          content: this.$t('Tenders.NoBidderWasApprovedForTheTenderOnQualification'),
          okText: this.$t('Tenders.Complete'),
          cancelText: this.$t('Tenders.ReturnToQualification'),
          loading: loading,
          onOk: async () => {
            await api.changeToAuction(this.tender.tenderId, model)
            if (this.$can('is', 'copyQualifiedBidsToAuction')) {
              this.$_deletePropFromLocalStorage(key, true)
            }
            await this.$_updateStatus(this.tender)
            await this.$_updateTenderAccess(this.tender)

            loading = false
            this.$Modal.remove() // якшо еубрати прошлий лоадер остається

            setTimeout(() => {
              this.$Modal.info({
                title: this.$t('Tenders.TenderCompleted', {item: this.tender.tenderNumber}),
                content: this.$t('Tenders.ReasonWasSentToParticipants'),
                okText: this.$t('Common.ThankYou'),
                loading: false,
              })
            }, 300) // для завершення анімації закриття
          }
        })
      } else {
        let step = 1
        if (!this.isNeewFirstStep) {
          step = this.allSteps?.length
        }
        this.openAll(step)
      }
    },
    openAll(step) {
      this.loading = 'all'
      this.steps = this.allSteps
      if ( step ) {
        this.info.step = step
      }
      this.openAdding()
    },
    openDates() {
      this.loading = 'dates'
      this.steps = [this.allSteps[1]]
      this.openAdding()
    },
    openAdding() {
      this.$root.$emit('closeSnackbar')
      this.loading = true
      this.$spinner.show()
      this.$store.dispatch('getEditingTender', this.$route.params?.id || this.$route.query?.id)
        .then(() => {
          this.loading = false
          this.add_data = true
        })
        .finally(() => {
          this.loading = false
          this.$spinner.close()
        })
    }
  },
  components: {
    TenderTerms,
    SpecifyTender,
    WeRecommendTender
  },
}
</script>
<style lang="scss" scoped>
.add-auction-data-fullscreen {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 12;
  background-color: var(--color-main-green);
}
</style>
